import styled from 'styled-components';
import { WhiteThree } from '../../styles/Colours';

export const LoadingContainer = styled.div`
  position: fixed;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background: ${WhiteThree};
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Loading = styled.div`
  display: inline-block;
  width: 100px;
`;

export const DynamicLoading = styled.div`
  position: fixed;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background: ${WhiteThree};
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  opacity: ${props => (props.state === 'entered' ? '1' : '0')};
`;



// WEBPACK FOOTER //
// ./src/components/Loading/LoadingStyles.js